// The setup steps' ids (F-HQ-03, ADR-0047; spec/14 §3.2, spec/13 §13.1): plain values only — no Zod — so the console
// and `@clavian/domain` read them through `@clavian/contracts/constants` without a route in the bundle. The schemas
// over them are `routes/setup.ts`; the problem document's `missingSteps` is `primitives/problem.ts`.
/**
 * The organisation's essential step: its first venue — with none there is nothing to open. Go live itself is a venue's
 * essentials alone (ADR-0047).
 */
export const ESSENTIAL_ORGANIZATION_SETUP_STEPS = ['firstVenue'];
/**
 * The organisation's suggested step: its business details (legal name and registered address — PAN is optional),
 * which a venue needs before it records a GST registration (ADR-0046) but not to open. It may be skipped.
 */
export const SUGGESTED_ORGANIZATION_SETUP_STEPS = ['businessDetails'];
/** Every organisation step, essential first, in the order the Setup page shows them. */
export const ORGANIZATION_SETUP_STEPS = [...ESSENTIAL_ORGANIZATION_SETUP_STEPS, ...SUGGESTED_ORGANIZATION_SETUP_STEPS];
export function isSuggestedOrganizationSetupStep(step) {
    return SUGGESTED_ORGANIZATION_SETUP_STEPS.includes(step);
}
/**
 * A venue's essential steps — the Go-live gate (the product owner, 2026-10-08): its opening hours are set, players have
 * a pass they can buy, and a PC is paired. Never skipped. `price` is "How players pay" (ADR-0058, 2026-10-12): done
 * when a pass is on sale at the venue; pay as you go and the wallet are set up beside it but do not make it done.
 */
export const ESSENTIAL_VENUE_SETUP_STEPS = ['openingHours', 'price', 'stationPaired'];
/** A venue's suggested steps: worth doing, never required. Each may be skipped. */
export const SUGGESTED_VENUE_SETUP_STEPS = [
    'taxMode',
    'lockdownTest',
    'printer',
    'payments',
    'kioskSignUp',
    'offlineCodes',
    'staffPin',
    'staffInvited',
    'firstSession',
];
/** Every venue step, essentials first, in the order the Setup page shows them. */
export const VENUE_SETUP_STEPS = [...ESSENTIAL_VENUE_SETUP_STEPS, ...SUGGESTED_VENUE_SETUP_STEPS];
export function isSuggestedVenueSetupStep(step) {
    return SUGGESTED_VENUE_SETUP_STEPS.includes(step);
}
export function isEssentialVenueSetupStep(step) {
    return ESSENTIAL_VENUE_SETUP_STEPS.includes(step);
}
//# sourceMappingURL=setup-steps.js.map